exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Text */\n.uu5-forms-radios {\n  margin-bottom: 1em;\n}\n.uu5-forms-radios:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n.uu5-forms-radios .uu5-forms-input-wrapper {\n  padding-top: 0.1em;\n  padding-bottom: 0.1em;\n}\n.uu5-forms-radios > .uu5-forms-label {\n  padding-top: 0.7em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/radios.less
// module id = 328
// module chunks = 0